export default __webpack_public_path__ + "static/Fly4-1d202c294b3b859b9cd136c77804ff24.mp3";